/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { useState } from 'react';

import { Typography } from '../../typography';
import { DatePicker } from '../DatePicker';

export const DatePickerWithTimeZoneBothMode = () => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(
    // Every day is Christmas in Needle :)
    new Date('2025-12-24'),
  );
  const [selectedTimeZone, setSelectedTimeZone] =
    useState<string>('America/New_York');

  return (
    <div style={{ maxWidth: '400px', padding: '20px' }}>
      <Typography variant="title-4" style={{ marginBottom: '16px' }}>
        DatePicker with TimeZone (Both Mode)
      </Typography>
      <Typography variant="body-medium" style={{ marginBottom: '24px' }}>
        This example shows the DatePicker with the TimeZonePicker in
        &quot;both&quot; mode, displaying both UTC offsets and city-based
        timezones in separate sections.
      </Typography>

      <DatePicker
        textInputProps={{
          label: 'Select Date and Time with Timezone',
        }}
        timePickerProps={{
          format: 'hh:mm',
        }}
        timeZonePickerProps={{
          mode: 'both',
          onChange: (tz) => {
            setSelectedTimeZone(tz);
          },
          value: selectedTimeZone,
        }}
        reactDatePickerProps={{
          dateFormat: 'yyyy-MM-dd hh:mm',
          onChange: (date) => {
            setSelectedDate(date);
          },
          selected: selectedDate,
          showTimeInput: true,
        }}
      />

      <div
        style={{
          backgroundColor: 'var(--theme-color-neutral-bg-default)',
          borderRadius: '4px',
          display: 'flex',
          flexDirection: 'column',
          marginTop: '24px',
          padding: '16px',
        }}
      >
        <Typography variant="label">Selected Values:</Typography>
        <Typography variant="body-small">
          <strong>Date: </strong>
          {selectedDate?.toISOString() ?? 'None'}
        </Typography>
        <Typography variant="body-small">
          <strong>Timezone:</strong> {selectedTimeZone || 'None'}
        </Typography>
      </div>
    </div>
  );
};

export default DatePickerWithTimeZoneBothMode;
